<template>
  <div class="container-fluid h-100">
    <div class="container mt-5 pt-5">

      <div style="display:flex;">
        <div class="col-5 mt-2">
          <input
            v-model="searchN"
            type="text"
            class="form-control"
            id="exampleFormControlInput1"
            placeholder="Buscar producto"
            autocomplete="off"
            style="text-transform: uppercase;"
            v-on:focus="clearInput"
          />
        </div>            
        <div class="col-1 mt-2">
          <button class="btn btn-danger btn-block" @click="search()">
            <i class="fa fa-search m-0 p-0" aria-hidden="true"></i>
          </button>
        </div>

        <div style="margin:auto 0px auto auto;" class="col-3 mt-2">
          <button class="btn btn-success btn-block" @click="getProducts()">
            Obtener listado completo
          </button>
        </div>
      </div>
            
      <template v-if="loading.history">
        <div class="d-flex justify-content-center">
          <div
            class="spinner-border text-danger"
            style="width: 4em; height: 4rem;"
            role="status"
          ></div>
        </div>
      </template>

      <paginate
        v-else
        class="ul-pagination"
        name="items"
        :list="items"
        :per="9"
      >
        <div class="row mt-1">
          <div class="col-12">
            <div class="table-responsive">
              <table class="table table-striped table-sm">
                <caption class="visually-hidden">Listado de Productos</caption>
                <thead>
                  <tr>
                    <th scope="col" style="text-align: left">SKU</th>
                    <th scope="col" style="text-align: left">Imagen</th>
                    <th scope="col" style="text-align: left">Nombre</th>
                    <th scope="col" style="text-align: left">Stock</th>
                    <th scope="col" style="text-align: left">Estado</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="(item, i) in paginated('items')"
                    :key="'d' + `item-${i}`"
                  >
                    <td style="text-align: left">
                      {{ item.sku }}
                    </td>
                    <td style="text-align: left">
                      <img
                        width="100"
                        class="img-item"
                        :src="item.img"
                        :alt="item.name"
                      />
                    </td>
                    <td style="text-align: left">
                      {{ item.name }}
                      <i
                        class="fa fa-info-circle text-info ml-1"
                        style="font-size: 20px;"
                        aria-hidden="true"
                        data-bs-toggle="tooltip"
                        data-bs-placement="bottom"
                        :title="item.description"
                      ></i>
                    </td>

                    <td style="text-align: left">
                      <h6>
                        <span class="badge badge-pill badge-danger">
                          {{ item.realStock }}
                        </span>
                      </h6>
                    </td>
                    <td style="text-align: left">
                      <label v-if="item.status_id == 1" style="color: #dc3545">
                        {{ item.status.name }}
                      </label>
                      <label v-else style="color: gray">
                        {{ item.status.name }}
                      </label>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </paginate>

      <div class="row ">
        <div
          class="col-12 col-md-3 col-lg-3 col-xl-3 col-sm-12 mt-4 pl-md-5 pl-xl-2"
        >
          <label class="text-p"> Página {{ page }} de {{ totalPage }} </label>
        </div>
        <div
          class="col-12 col-md-9 col-lg-9 col-xl-9 col-sm-12 mt-4 center-paginate"
        >
          <paginate-links
            @change="pageChange"
            for="items"
            :limit="2"
            :show-step-links="true"
            :step-links="{ next: '>', prev: '<' }"
            :classes="{ ul: 'pagination', li: 'page-item', a: 'page-link' }"
          >
          </paginate-links>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import $ from "jquery";
import axios from 'axios';

export default {
  data() {
    return {
      listFile: [],
      searchN: "Buscar producto",
      errorsFile: false,
      errorsFile2: false,
      errorsTitle: false,
      errorsStatus: false,
      form: {
        id: 0,
        urlImg: "",
        name: "",
        status: null,
        points: null,
        price: null,
        description: ""
      },
      errors: {
        id: 0,
        urlImg: "",
        name: "",
        status: null,
        points: null,
        price: null,
        description: ""
      },
      currentForm: {},
      file: null,
      loading: {
        publicate: false,
        history: false,
        changeDoc: false,
        order: false
      },
      hidden: {
        btn: false
      },
      items: [],
      paginate: ["items"],
      page: 1,
      totalPage: 1,
      isWon: false
    };
  },
  methods: {
    search() {
      if(this.searchN == 'Buscar producto' || this.searchN == ''){
        this.$swal({
          confirmButtonColor: "#dc3545",
          icon: "warning",
          title: "Oops...",
          text: 'Ingrese algo para buscar'
        });
        return false;
      }
      this.items = [];
      this.loading.history = true;
      axios
        .get("api/moto/products/search/" + this.searchN)
        .then(res => {
          if (res.data.cod == 0) {
            this.items = res.data.data;
            this.totalPage = Math.ceil(parseInt(this.items.length) / 10);
            this.items.map(item => {
            let realStock = 0;
              item.product_size.map(size => {
                realStock = realStock + parseInt(size.availability)
              });
              item.realStock = realStock
            });
            // console.log(JSON.stringify(this.items));
          }
          this.loading.history = false;
        })
        .catch(error => {
          this.loading.history = false;
          this.$swal({
            confirmButtonColor: "#dc3545",
            icon: "error",
            title: "Oops...",
            text: error.response.data.message
          });
        });
    },
    getProducts() {
      this.items = [];
      this.loading.history = true;
      axios
        .get("api/moto/products")
        .then(res => {
          if (res.data.cod == 0) {
            this.items = res.data.data;
            this.totalPage = Math.ceil(parseInt(this.items.length) / 10);
            this.items.sort((a, b) => {
              return a.name.localeCompare(b.name);
            });
          }
          // console.log(JSON.stringify(this.items));
          this.items.map(item => {
            let realStock = 0;
            item.product_size.map(size => {
              realStock = realStock + parseInt(size.availability)
            });
            item.realStock = realStock
          });
          this.loading.history = false;
        })
        .catch(error => {
          this.loading.history = false;
          this.$swal({
            confirmButtonColor: "#dc3545",
            icon: "error",
            title: "Oops...",
            text: error.response.data.message
          });
        });
    },
    pageChange(toPage) {
      this.page = toPage;
    },
    clearInput() {
      this.searchN = "";
    },
  },
  mounted() {
    this.pageChange(1);
    this.getProducts();
  },
  watch: {
    // searchN: function(newN) {
    //   if (!newN) {
    //     setTimeout(() => this.getProducts(), 15000);
    //   }
    // },
    "form.name": function(newV) {
      if (!newV) {
        this.errors.name = "El nombre del producto es requerido.";
      } else {
        this.errors.name = false;
      }
    },
    "form.description": function(newV) {
      if (!newV) {
        this.errors.description = "La descripción del producto es requerida.";
      } else {
        this.errors.description = false;
      }
    },
    "form.points": function(newV) {
      if (!newV) {
        this.errors.points = "La cantidad de puntos es requerida.";
      } else {
        this.errors.points = false;
      }
    },
    "form.price": function(newV) {
      if (!newV) {
        this.errors.price = "El precio del producto es requerido.";
      } else {
        this.errors.price = false;
      }
    },
    "form.status": function(newV) {
      if (!newV) {
        this.errors.status = "El estado del producto es requerido.";
      } else {
        this.errors.status = false;
      }
    },
    "form.urlImg": function(newV) {
      if (!newV) {
        this.errors.urlImg = "La imagen del producto es requerida.";
      } else {
        this.errors.urlImg = false;
      }
    }
  }
};
</script>

<style>
.container-fluid,
.container-lg,
.container-md,
.container-sm,
.container-xl {
  padding-right: 0px !important;
  padding-left: 0px !important;
  overflow: hidden;
}
.div-button {
  margin-top: 50px;
  text-align: left;
}
.is-danger {
  border: solid 2px !important;
  border-color: #e9434c !important;
}
.modal-title {
  color: black;
  font-weight: bold;
}
.modal-question {
  border: solid 3px;
  border-color: #dc3545;
  border-radius: 15px;
}
label {
  color: black;
  margin-right: 4px;
}
.img-banner {
  display: block;
  width: 25%;
  text-align: center;
  margin: auto;
}
td {
  text-align: center;
  vertical-align: -webkit-baseline-middle;
  cursor: all-scroll;
}
.table-container {
  overflow: auto;
}
h5 {
  margin-bottom: 10px !important;
}
.commentary {
  text-align: left;
  color: #1da5df;
  font-size: 13px;
}
.page-item.active .page-link {
  border-style: none;
  border-radius: 20px;
  background-color: #dc3545;
}
a.page-link {
  color: black;
  cursor: pointer;
}
a.page-link:hover {
  color: #dc3545;
}
.page-link {
  background-color: #f5f5dc00;
  border-radius: 20px;
  border-color: none;
}
.page-item.disabled .page-link {
  color: #dc3545;
  background-color: #fff0;
  border-color: #dee2e600;
}
.ul-pagination {
  padding: 0px;
}
.visually-hidden {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  border: 0;
}
</style>
